import { useTranslation } from 'react-i18next'
import { SHORTCUT_GROUPS, isMacPlatform, resolveCombo } from '../../keyboardShortcuts'
const shown = new Set(['timeline.playPause', 'timeline.scrub', 'timeline.fineScrub', 'timeline.fullscreen', 'timeline.shot', 'timeline.zoomOut', 'timeline.zoomIn', 'timeline.wheelZoom', 'timeline.wheelScroll'])
export function TimelineShortcutLegend() {
  const { t } = useTranslation('canvas')
  return <div className="flex shrink-0 flex-wrap items-center gap-x-4 gap-y-1 border-t border-border-subtle bg-surface-0 px-3 py-2 text-xs text-muted-foreground" data-testid="timeline-shortcut-legend">
    {SHORTCUT_GROUPS.find((group) => group.scope === 'timeline')?.bindings.filter((binding) => shown.has(binding.id)).map((binding) =>
      <span key={binding.id} className="inline-flex items-center gap-1">
        {binding.combos.map((combo, index) => <kbd key={index} className="rounded border border-border bg-surface-1 px-1 font-mono">{resolveCombo(combo, isMacPlatform()).join(' ')}</kbd>)}{t(binding.labelKey)}
      </span>)}
  </div>
}
